import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

// components
import Error from './components/Error/Error';

// pages
import MainLayout, { mainLayoutLoader } from './layout/MainLayout';
import Step1Page, { step1Loader, step1Action } from './pages/Step1Page';
import Step2Page, { step2Loader, step2Action } from './pages/Step2Page';
import Step3Page, { step3Loader, step3Action } from './pages/Step3Page';
import Step4Page, { step4Loader } from './pages/Step4Page';

// library imports
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// css
import './App.css';
import NotFound from './components/NotFound';

const router = createBrowserRouter([{
  path: "/",
  element: <MainLayout />,
  loader: mainLayoutLoader,
  errorElement: <Error />,
  children: [{
    path: "/",
    loader: step1Loader,
    element: <Step1Page />,
    action: step1Action,
  }, {
    path: "step2",
    loader: step2Loader,
    element: <Step2Page />,
    action: step2Action,
  }, {
    path: "step3",
    loader: step3Loader,
    element: <Step3Page />,
    action: step3Action,
  }, {
    path: "step4",
    loader: step4Loader,
    element: <Step4Page />,
  }]
}, {
  path: "*",
  element: <NotFound />,
}
], {
  basename: process.env.REACT_APP_BASEURL,
});

const App: React.FC = () => {
  return <>
    <RouterProvider router={router} />
    <ToastContainer />
  </>
}

export default App;
